module.exports = __webpack_public_path__ + "static/media/start-timer.2ff62f34.svg";